import spinner from '../assets/svg/spinner.svg'
export default function Spinner({ local = false }) {
  return local ? (
    <div
      id="spinner"
      className="w-full text-center text-black text-m font-medium uppercase rounded transition duration-150 ease-in-out mt-2 mb-2"
    >
      <div className="w-full bg-black bg-opacity-50 flex items-center justify-center z-[2000]">
        <div>
          <img src={spinner} alt="Loading..." className="h-24" />
        </div>
      </div>
    </div>
  ) : (
    <div
      id="spinner"
      className="bg-black bg-opacity-50 flex items-center justify-center fixed left-0 right-0 bottom-0 top-0 z-[2000]"
    >
      <div>
        <img src={spinner} alt="Loading..." className="h-24" />
      </div>
    </div>
  )
}
